import { mq } from "@/constants/breakpoints";
import { css } from "@emotion/react";
import ContentfulImage from "../ContentfulImage/ContentfulImage";

interface BlogPageHeroImageProps {
  featuredMedia: any;
}

const BlogPageHeroImage = ({ featuredMedia }: BlogPageHeroImageProps) => {
  return (
    <div
      css={css`
        --gapNumber: 9;
        --gap: calc(var(--gapNumber) * 1px);
        ${mq["sm"]} {
          --gapNumber: 14;
        }
        ${mq["lg"]} {
          --gapNumber: 20;
        }
        max-width: calc(480px + (var(--gap) * 2));
        margin: auto;
        padding-bottom: 16px;
        ${mq["sm"]} {
          padding-bottom: 40px;
        }
        ${mq["lg"]} {
          max-width: calc(680px + (var(--gap) * 2));
          position: absolute;
          width: 720px;
        }
      `}
    >
      <div
        css={css`
          position: relative;
          padding-top: calc(
            (${featuredMedia.height} + (2 * var(--gapNumber))) /
              (${featuredMedia.width} + (2 * var(--gapNumber))) * 100%
          );
          * {
            position: absolute;
            width: calc(100% - (var(--gap) * 2));
            height: calc(100% - (var(--gap) * 2));
            right: 0;
            bottom: 0;
            z-index: 0;
          }
          div {
            background: linear-gradient(
              103.92deg,
              rgba(255, 255, 255, 0.1) -0.74%,
              rgba(190, 220, 255, 0.1) 99.87%
            );
            backdrop-filter: blur(39.206px);
          }
        `}
      >
        <div
          css={css`
            top: calc(var(--gap) * 2);
            left: 0;
            border-radius: 11.4px;
            ${mq["sm"]} {
              border-radius: 17.7px;
            }
            ${mq["lg"]} {
              border-radius: 25px;
            }
          `}
        />
        <div
          css={css`
            top: var(--gap);
            left: var(--gap);
            border-radius: 9.1px;
            ${mq["sm"]} {
              border-radius: 14.2px;
            }
            ${mq["lg"]} {
              border-radius: 20px;
            }
          `}
        />
        <ContentfulImage
          alt={featuredMedia.title}
          src={featuredMedia.url}
          width={featuredMedia.width}
          height={featuredMedia.height}
          css={css`
            top: 0;
            left: calc(var(--gap) * 2);
            border-radius: 7.3px;
            ${mq["sm"]} {
              border-radius: 11.3px;
            }
            ${mq["lg"]} {
              border-radius: 16px;
            }
          `}
        />
      </div>
    </div>
  );
};

export default BlogPageHeroImage;
